import { createStore } from "vuex";
import maintenance from "./modules/maintenance";

export default createStore({
  modules: {
    maintenance,
  },
});
